module.exports = __webpack_public_path__ + "img/screenr-lr.87546a8a.png";